import { Grid } from "@mui/material";
import { AppUngatedParkingPrefix } from "constants/app.constants";
import IncidentPageHeader from "features/app-ungated-parking/header/IncidentTableHeader";
import IncidentsPage from "features/app-ungated-parking/IncidentsPage";
import React from "react";
import { Helmet } from "react-helmet";
import platformityLogo from "assets/images/platformity-favicon-logo.png";

interface IncidentsProps {}

const Incidents: React.FC<IncidentsProps> = () => {
    return (
        <>
            <Helmet>
                <title>{AppUngatedParkingPrefix} | Incidents</title>
                <link rel="icon" id="pnr-incident" type="image/png" href={platformityLogo} sizes="32x32" />
            </Helmet>
            <Grid container>
                <Grid item xs={12}>
                    <IncidentPageHeader lastUpdated="" />
                </Grid>
                <Grid item xs={12} sx={{ marginTop: "24px" }}>
                    <IncidentsPage />
                </Grid>
            </Grid>
        </>
    );
};

export default Incidents;
